import { AxiosResponse } from "axios";
import { axiosInstance } from "./common";

export interface SARFAESIDetails {
  enabled: boolean;
  status_of_recovery?: string | null;
}

export interface DRTDetails {
  enabled: boolean;
  name?: string | null;
  case_number?: string | null;
  status_of_recovery?: string | null;
}

export interface NCLTDetails {
  enabled: boolean;
  name?: string | null;
  case_number?: string | null;
  status_of_recovery?: string | null;
}

export interface OtherCourtCasesDetails {
  enabled: boolean;
  status?: string;
}

export interface RecoveryDetails {
  loan_reference_id: string;
  sarfaesi_details?: SARFAESIDetails;
  drt_details?: DRTDetails;
  nclt_details?: NCLTDetails;
  other_court_case_details?: OtherCourtCasesDetails;
}

export interface RecoveryDetailsResponse {
  recovery_details: RecoveryDetails[];
}

export interface ExportRecoveryDetailsRequest {
  recovery_details: RecoveryDetails[];
}

export const RecoverAPIs = {
  getRecoveryDetails: async (
    case_id: string
  ): Promise<ExportRecoveryDetailsRequest> => {
    const response: AxiosResponse<ExportRecoveryDetailsRequest> =
      await axiosInstance.get(`/v1/cases/${case_id}/recovery-details`);
    return response.data;
  },

  upsertRecoveryDetails: async (
    case_id: string,
    request: ExportRecoveryDetailsRequest
  ): Promise<ExportRecoveryDetailsRequest> => {
    const response: AxiosResponse<ExportRecoveryDetailsRequest> =
      await axiosInstance.put(`/v1/cases/${case_id}/recovery-details`, request);
    return response.data;
  },
};
